module.exports = __webpack_public_path__ + "static/img/jiaoyanzu_banner.97701096.png";